import Logger from './Logger';

export default new Logger();
